import { IS_APPLE_DEVICE, IS_ANDROID_DEVICE, IS_MOBILE } from '@senet-uiverse/common';

import BASE from './app.base';

export const redirectMobileToStore = () => {
  if (IS_MOBILE) {
    if (IS_APPLE_DEVICE) {
      window.location.href = BASE.iosAppUrl;
    } else if (IS_ANDROID_DEVICE) {
      window.location.href = BASE.androidAppUrl;
    }
  }
};
